import React from "react";

export const VehicleSVGIcon = ({ status }) => {
  return (
    <svg
      id="Layer_1"
      width="24"
      height="24"
      viewBox="0 0 352.6333 187.5408"
      enableBackground="new 0 0 352.6333 187.5408"
      xmlSpace="preserve"
    >
      <g className={status === "active" ? "category-svg-active" : "category-svg-inactive"}>
        <path
          className="svg-path"
          d="M82.4185,126.5665h19.7199c-2.1633-11.6429-8.2381-21.9042-16.8156-29.3774l-10.4047,16.5843      C78.3293,117.3591,80.9313,121.7195,82.4185,126.5665z"
        />
        <path
          className="svg-path"
          d="M51.5106,168.3544c-17.8234,0-32.3245-14.5007-32.3245-32.3241c0-17.8235,14.5011-32.3242,32.3245-32.3242      c3.4398,0,6.7535,0.5453,9.8655,1.5452l10.4047-16.5842c-6.2219-2.6664-13.0724-4.1474-20.2702-4.1474      C23.0621,84.5198,0,107.5818,0,136.0303s23.0621,51.5105,51.5106,51.5105c25.8915,0,47.3145-19.1048,50.9576-43.985H82.9413      C79.5399,157.7604,66.7427,168.3544,51.5106,168.3544z"
        />
        <path
          className="svg-path"
          d="M301.1227,84.5198c-4.4985,0-8.8608,0.58-13.0203,1.6635l8.3259,17.8678c1.5334-0.2241,3.0999-0.3448,4.6943-0.3448      c17.8235,0,32.3246,14.5007,32.3246,32.3242c0,17.8234-14.5011,32.3241-32.3246,32.3241      c-17.8234,0-32.3245-14.5007-32.3245-32.3241c0-9.5944,4.2063-18.2211,10.8665-24.1462l-8.3257-17.8676      c-13.1426,9.334-21.7268,24.6666-21.7268,42.0138c0,28.4485,23.062,51.5105,51.5105,51.5105s51.5106-23.062,51.5106-51.5105      S329.5712,84.5198,301.1227,84.5198z"
        />
        <path
          className="svg-path"
          d="M298.7308,142.5965l8.958-4.1743l-27.8301-59.7249L244.5189,2.8558c-1.0134-2.1752-3.448-3.3093-5.7595-2.6855      l-27.2837,7.3202l2.5608,9.5457l23.2769-6.2452l7.7656,16.6655c-11.6201,0.194-74.5686,2.6233-88.0249,32.4194h-46.6393      l-20.7524-10.572c-4.8423-2.4669-10.1298-3.9384-15.5503-4.3276l-33.5284-2.4078c-4.0087-0.2879-7.795,1.8716-9.5881,5.4686      l-1.2928,2.5934c-1.2594,2.5265-1.4653,5.4493-0.5726,8.1275l0.1052,0.3157L1.4247,84.2543l3.7304,4.12L31.8146,64.236      l51.0133,6.8229l0.6466,0.0865l1.3585,2.363l-33.288,53.0582H63.35l27.1277-43.2394l1.6936,2.9459l23.1644,40.2935l1.7246,2.9999      H36.9904v10.9894h86.3878l1.4197,2.4694c0.1041,0.1812,0.2208,0.3525,0.329,0.5305c4.6128,7.5875,12.8483,12.2485,21.7579,12.2485      h64.0424l33.5815-69.0524h-37.9973v-3.0504h39.4807l2.2917-4.7124h-58.2915v-3.0504h61.1295l14.8219-3.7054l5.1016,10.9484      L298.7308,142.5965z"
        />
        <path
          className="svg-path"
          d="M286.0756,56.6476c9.3351,0,9.3351-33.8044,0-33.8044c-9.3348,0-16.9021,7.5659-16.9021,16.9022      S276.7407,56.6476,286.0756,56.6476z"
        />
      </g>
    </svg>
  );
}
